import { render, staticRenderFns } from "./CardNftBox.vue?vue&type=template&id=39998e9e&"
import script from "./CardNftBox.vue?vue&type=script&lang=js&"
export * from "./CardNftBox.vue?vue&type=script&lang=js&"
import style0 from "./CardNftBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports